<script lang="ts">
    import type * as t from "./types";

    import { onMount } from "svelte";
    import store from "./quiz-store";
    import { goToNextStep } from "./quiz-controller.svelte";
    import eventLogger from "./quiz-event-logger";

    export let step: t.Step;
    const { title, subtitle, footer, ctaButton } = step;

    let button: HTMLButtonElement;
    let isTouching = false;
    let hasTouch = "ontouchstart" in window;

    function handleClickCtaButton() {
        eventLogger.logEvent("game_start", {
            total_steps: $store.totalSteps,
        });
        goToNextStep();
    }

    onMount(() => {
        if (!hasTouch) {
            return;
        }

        button.addEventListener("touchstart", () => {
            isTouching = true;
        });

        button.addEventListener("touchend", () => {
            isTouching = false;
        });
    });
</script>

<div class="flex max-w-md flex-1 flex-col items-center justify-between gap-y-2">
    <div></div>

    <section class="flex flex-col items-center gap-5">
        <span class="cta-text text-center text-2xl sm:text-3xl">
            <span class="block font-bold">{title}</span>
            <span class="subtitle">
                {@html subtitle}
            </span>
        </span>
        <button
            bind:this={button}
            class="
        cta-button rounded-lg px-5 py-3 text-xl
        transition-[font-weight,transform]
    "
            class:hover:scale-105={!hasTouch}
            class:hover:font-light={!hasTouch}
            class:scale-105={isTouching}
            class:font-light={isTouching}
            on:click={handleClickCtaButton}
        >
            {ctaButton.text}
        </button>
    </section>

    <div class="text-center text-base text-[var(--secondary-color)]">
        {@html footer}
    </div>
</div>

<style>
    .subtitle {
        /* workaround to set a minimum font size */
        font-size: calc(10px + 0.3em);
    }
    .cta-button {
        background-color: var(--primary-color);
        color: var(--text-on-primary-color);
    }

    .cta-text {
        color: black;
    }
</style>
